import { BOARD_SIZE } from '../constants';

export const getPossibleWalls = (walls, stone) => {
  if (!stone) return [];

  const possibleWalls = [];

  // Check horizontal walls
  if (stone.row > 0 && !walls.horizontal[stone.row][stone.col]) {
    possibleWalls.push({
      type: 'horizontal',
      row: stone.row,
      col: stone.col
    });
  }
  if (stone.row < BOARD_SIZE - 1 && !walls.horizontal[stone.row + 1][stone.col]) {
    possibleWalls.push({
      type: 'horizontal',
      row: stone.row + 1,
      col: stone.col
    });
  }

  // Check vertical walls
  if (stone.col > 0 && !walls.vertical[stone.row][stone.col]) {
    possibleWalls.push({
      type: 'vertical',
      row: stone.row,
      col: stone.col
    });
  }
  if (stone.col < BOARD_SIZE - 1 && !walls.vertical[stone.row][stone.col + 1]) {
    possibleWalls.push({
      type: 'vertical',
      row: stone.row,
      col: stone.col + 1
    });
  }

  return possibleWalls;
};

export const isValidWallPlacement = (walls, stone, type, row, col) => {
  if (!stone) return false;

  const possibleWalls = getPossibleWalls(walls, stone);

  return possibleWalls.some(wall =>
    wall.type === type && wall.row === row && wall.col === col
  );
}; 
